import { NaZakazkuTrideniList } from '@/components/vyroba/NaZakazkuTrideniList';

/**
 * Náhled na třídění objednávek ve stavech „Ušijeme (pro Vás/pre vás) do
 * 7/10/14 dní" — pro CZ i SK ukáže termín = datum objednávky + lhůta,
 * posunutý na předchozí pracovní den při víkendu/svátku, i navrhovaný
 * SKUTEČNÝ termín výroby. Jen výpis — nic se tu nepřepíná, to pořád dělá
 * kolegyně ručně. Stejný náhled je i jako záložka v „Termíny výroby".
 */
export function TrideniNaZakazkuPage() {
  return (
    <>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-text">Třídění objednávek na zakázku</h1>
      </div>

      <div className="rounded-xl border border-primary/30 bg-primary-25 px-5 py-4 mb-6">
        <div className="text-xs font-bold text-primary uppercase tracking-wide mb-2">
          Jak funguje třídění
        </div>
        <ul className="text-sm text-text space-y-1 list-disc pl-5">
          <li>
            Bereme jen <strong>nové</strong> objednávky z CZ i SK e-shopu (od nasazení téhle záložky
            dál) ve stavu „Ušijeme (pro Vás/pre vás) do 7/10/14 dní".
          </li>
          <li>
            U KAŽDÉ položky objednávky se zjistí, jestli je na zakázku (slib = datum objednávky +
            lhůta, posunuto na předchozí pracovní den při víkendu/svátku), nebo už rozplánovaná na
            konkrétní termín ve výrobě.
          </li>
          <li>
            O termínu celé objednávky rozhoduje ta <strong>nejpozdější</strong> z položek — když má
            jedna položka termín ve výrobě dřív, ale druhá je na zakázku s pozdějším slibem, platí
            ten pozdější slib.
          </li>
          <li>
            Nezbývá-li po téhle kontrole nic, poslední pojistkou je živá skladovost — objednávka je
            pak označená jako <strong>Vyřizuje se</strong>.
          </li>
          <li>
            Je to jen náhled — nic se tu samo nepřetřiďuje, nic se nezapisuje a neposílá se ani
            e-mail. O skutečné zařazení se pořád stará kolegyně ručně.
          </li>
        </ul>
      </div>

      <NaZakazkuTrideniList />
    </>
  );
}
